<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class matchSizeMenus extends Vue {
        get hasTextColor() {
            return this.$store.state.shape.hasText;
        }
        get selectShapesFlag() {
            return this.$store.state.shape.selectShapesFlag;
        }
        set selectShapesFlag(v) {
            this.$store.commit("setShapeStatus", {
                type: "selectShapesFlag",
                data: v,
            });
        }
        get menuList() {
            return {
                list: [
                    { key: "shapeStyle", label: this.$t("shapeStyle") },
                    { key: "fillColor", label: this.$t("fillColor") },
                    { key: "lineColor", label: this.$t("lineColor") },
                    { key: "fill&lineColor", label: this.$t("fill&lineColor") },
                    { key: "textColor", label: this.$t("textColor"), disabled: !this.hasTextColor },
                ],
            };
        }
        handleClicks(...args) {
            let key = args[0];
            if (key == "textColor") {
                this.hasTextColor && this.selectShapesBys(key);
            } else {
                this.selectShapesBys(key);
            }
        }
        selectShapesBys(type) {
            this.selectShapesFlag = type || "";
            window["_view"].selectShapesBy(type);
            this.$track("select", "Same type shape", type);
            this.$emit("closeDrop");
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "shapeStyle": "形状样式",
    "fillColor": "填充颜色",
    "lineColor": "线框颜色",
    "fill&lineColor": "填充及线框颜色",
    "textColor": "文本颜色"
  },
  "en": {
    "shapeStyle": "Shape style",
    "fillColor": "Fill Color",
    "lineColor": "Wireframe Color",
    "fill&lineColor": "Fill and wireframe color",
    "textColor": "Text Color"
  },
  "fr": {
    "shapeStyle": "Style de forme",
    "fillColor": "Couleur de remplissage",
    "lineColor": "Couleur filaire",
    "fill&lineColor": "Couleur de remplissage et filaire",
    "textColor": "Couleur du texte"
  },
  "de": {
    "shapeStyle": "Formstil",
    "fillColor": "Füllfarbe",
    "lineColor": "Wireframe Color",
    "fill&lineColor": "Füll- und Drahtgitterfarbe",
    "textColor": "Textfarbe"
  },
  "jp": {
    "shapeStyle": "形状のスタイル",
    "fillColor": "塗りつぶしの色",
    "lineColor": "ワイヤーフレームカラー",
    "fill&lineColor": "塗りつぶしとワイヤーフレームの色",
    "textColor": "テキストの色"
  },
  "es": {
    "shapeStyle": "Estilo de forma",
    "fillColor": "Color de relleno",
    "lineColor": "Color de estructura metálica",
    "fill&lineColor": "Color de relleno y estructura alámbrica",
    "textColor": "Color del texto"
  },
  "pt": {
    "shapeStyle": "Tamanho igual",
    "fillColor": "Cor de preenchimento",
    "lineColor": "Cor do wireframe",
    "fill&lineColor": "Cor de preenchimento e wireframe",
    "textColor": "Cor do texto"
  },
  "it": {
    "shapeStyle": "Stile di forma",
    "fillColor": "Colore riempimento",
    "lineColor": "Wireframe Color",
    "fill&lineColor": "Colore riempimento e wireframe",
    "textColor": "Colore testo"
  },
  "tw": {
    "shapeStyle": "形狀樣式",
    "fillColor": "填充顏色",
    "lineColor": "線框顏色",
    "fill&lineColor": "填充及線框顏色",
    "textColor": "文本顏色"
  }
}
</i18n>
